import React, { useState, useEffect } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import {
  Box,
  Button,
  ButtonGroup
} from '@material-ui/core';

const BookingsTable = (props) => {
  
  const [currentTable, setCurrentTable] = useState([]);
  const [month, setMonth] = useState(true);

  const columns = [
    { label: "Day", name: "day" },
    { label: "Month", name: "month" },
    { label: "Year", name: "year" },
    { label: "Total Bookings", name: "bookings" }
  ];

  // Initially, The table will be set with the monthly data
  useEffect(() => {
    const result = [];
    let startDate = moment(props.dates.startDate);

    // The additional 'OR' condition is important to make sure the loop runs even if the months are the same.
    while (startDate.isBefore(props.dates.endDate) || startDate.isSame(props.dates.endDate, 'month')) {

      let totalMonthBookings = props.allSalesOrders.reduce((prevBooking, currentBooking) => {
        if(startDate.isSame(currentBooking.startDate, 'month')) return prevBooking + currentBooking.total
        else return prevBooking
      }, 0);

      result.push({
        month: startDate.format("MMMM"),
        year: startDate.format("YYYY"),
        bookings: totalMonthBookings
      });

      startDate.add(1, 'month');
    }
    setCurrentTable(result.reverse());

  }, [props.allSalesOrders, props.dates]);

  const options = {
    selectableRows: 'none',
    viewColumns: false
  };

  // Function to group Sales by Day
  const groupByDay = () => {
    const result = []
    let startDate = moment(props.dates.startDate)

    while (startDate.isBefore(props.dates.endDate) || startDate.isSame(props.dates.endDate, 'day')) {

      let totalDayBookings = props.allSalesOrders.reduce((prevBooking, currentBooking) => {
        if(startDate.isSame(currentBooking.startDate, 'day')) return prevBooking + currentBooking.total
        else return prevBooking
      }, 0);

      result.push({
        day: `${startDate.format("dddd")}, ${startDate.format("DD/MM")}`,
        year: startDate.format("YYYY"),
        bookings: totalDayBookings
      });

      startDate.add(1, 'day');
    }
    setCurrentTable(result.reverse());
    setMonth(false);
  };

  // Function to group Sales by Month
  const groupByMonth = () => {
    const result = []
    let startDate = moment(props.dates.startDate)

    // The additional 'OR' condition is important to make sure the loop runs even if the months are the same.
    while (startDate.isBefore(props.dates.endDate) || startDate.isSame(props.dates.endDate, 'month')) {

      let totalMonthBookings = props.allSalesOrders.reduce((prevBooking, currentBooking) => {
        if(startDate.isSame(currentBooking.startDate, 'month')) return prevBooking + currentBooking.total
        else return prevBooking
      }, 0);

      result.push({
        month: startDate.format("MMMM"),
        year: startDate.format("YYYY"),
        bookings: totalMonthBookings
      });
      
      startDate.add(1, 'month');
    }
    setCurrentTable(result.reverse());
    setMonth(true);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: 2
        }}
      >
        <ButtonGroup variant="text" color="primary" aria-label="text primary button group">
          <Button
            onClick={groupByDay}
          >
            Daily
          </Button>
          <Button
            onClick={groupByMonth}
          >
            Monthly
          </Button>
        </ButtonGroup>
      </Box>
      <MUIDataTable
        title={"Bookings"}
        data={currentTable}
        columns={ month ? columns.filter(column => column.name !== "day") : columns.filter(column => column.name !== "month") }
        options={options}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 2
        }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={props.hideSalesTable}
        >
          Return
        </Button>
      </Box>
    </Box>
  )
};

export default BookingsTable;